/**
 * SGKE361A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SuspensionjiTreatment {

    /**
     * メーターガス栓閉止フラグ
     */
    meterGassenShutoffflag?: string;
    /**
     * メーター休止措置フラグ
     */
    meterPauseSochiflag?: string;
    /**
     * 点検業務引継先フラグ
     */
    inspectiontaskTakeovertoFlg?: string;
    /**
     * 点検業務引継先コード
     */
    inspectiontaskTakeovertoCode?: string;
    /**
     * 点検業務引継先コード名称
     */
    inspectiontaskTakeovertoCodeaname?: string;
}

